import React from 'react'

import formatValue from '../../../../utils/valueFormatting'

export default ({ value, col, type, extraCSS }) => (
    <div className={`${extraCSS} tableCell is-size-7`}>
        {type === 'string' ? value : formatValue(value, col)}
    </div>
)
